import { render } from "./AddEditInventory.vue?vue&type=template&id=99a4bd46"
import script from "./AddEditInventory.vue?vue&type=script&lang=js"
export * from "./AddEditInventory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__